import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  showDialog: boolean;
};

type Actions = {
  setShowDialog: (showDialog: boolean) => void;
};

const INITIAL_STATE: State = {
  showDialog: false,
};

export const useDialog = create<State & Actions>()(
  devtools((set) => {
    return {
      ...INITIAL_STATE,
      setShowDialog: (showDialog) => set({ showDialog }),
    };
  })
);
